import {JogadorDetalhe} from "./pages/JogadorDetalhe";
import {JogosDoDia} from "./pages/JogosDoDia";
import {Ranking} from "./pages/Ranking";
import {PrepararJogos} from "./pages/PrepararJogos";
import {HistoricoJogos} from "./pages/HistoricoJogos";
import {Jogadores} from "./pages/Jogadores";
import {Home} from "./pages/Home";
import {Login} from "./pages/Login";

const AppRoutes = [
    {
        index: true,
        path: '/',
        element: <Home/>
    },
    {
        path: '/jogadores',
        //auth: true,
        element: <Jogadores/>
    },
    {
        path: '/historico-jogos',
        element: <HistoricoJogos/>
    },
    {
        path: '/preparar-jogos/:id?',
        element: <PrepararJogos/>
    },
    {
        path: '/ranking',
        element: <Ranking/>
    },
    {
        path: '/jogos-do-dia/:id?',
        element: <JogosDoDia/>
    },
    {
        path: '/jogador/:id',
        element: <JogadorDetalhe/>
    },
    {
        path: '/login',
        element: <Login/>
    }
];

export default AppRoutes;
